import { createGlobalStyle } from 'styled-components';
import { COLOR } from '../../constants/theme';

// antd 4.16 ships precompiled CSS in its default blue (#1890ff) and can't be
// themed at runtime, so the primary-colour states of the components this app
// uses are set to the brand colour here. These rules load after antd.css and
// use antd's own selectors, so they win at the same specificity.
const PRIMARY_SHADOW = 'rgba(5, 82, 240, 0.2)';

const GlobalStyle = createGlobalStyle`
  ::selection {
    background: ${COLOR.primary};
  }

  a,
  a.ant-typography,
  .ant-typography a {
    color: ${COLOR.primary};
  }

  a:hover,
  a.ant-typography:hover,
  .ant-typography a:hover {
    color: ${COLOR.primaryDark};
  }

  /* Button */
  .ant-btn-primary {
    border-color: ${COLOR.primary};
    background: ${COLOR.primary};
  }

  .ant-btn-primary:hover,
  .ant-btn-primary:focus,
  .ant-btn-primary:active {
    border-color: ${COLOR.primaryDark};
    background: ${COLOR.primaryDark};
  }

  .ant-btn:not(.ant-btn-primary):not(.ant-btn-text):not(.ant-btn-link):not(.ant-btn-dangerous):hover,
  .ant-btn:not(.ant-btn-primary):not(.ant-btn-text):not(.ant-btn-link):not(.ant-btn-dangerous):focus {
    border-color: ${COLOR.primary};
    color: ${COLOR.primary};
  }

  .ant-btn-link {
    color: ${COLOR.primary};
  }

  .ant-btn-link:hover,
  .ant-btn-link:focus {
    color: ${COLOR.primaryDark};
  }

  /* Checkbox */
  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner,
  .ant-checkbox-checked::after {
    border-color: ${COLOR.primary};
  }

  .ant-checkbox-checked .ant-checkbox-inner,
  .ant-checkbox-indeterminate .ant-checkbox-inner::after {
    border-color: ${COLOR.primary};
    background-color: ${COLOR.primary};
  }

  /* Radio */
  .ant-radio-wrapper:hover .ant-radio,
  .ant-radio:hover .ant-radio-inner,
  .ant-radio-input:focus + .ant-radio-inner,
  .ant-radio-checked .ant-radio-inner,
  .ant-radio-checked::after {
    border-color: ${COLOR.primary};
  }

  .ant-radio-input:focus + .ant-radio-inner {
    box-shadow: 0 0 0 3px ${PRIMARY_SHADOW};
  }

  .ant-radio-inner::after {
    background-color: ${COLOR.primary};
  }

  .ant-radio-button-wrapper:hover {
    color: ${COLOR.primary};
  }

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    border-color: ${COLOR.primary};
    color: ${COLOR.primary};
  }

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
    background-color: ${COLOR.primary};
  }

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover,
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):first-child {
    border-color: ${COLOR.primary};
    color: ${COLOR.primary};
  }

  /* Input, Select and DatePicker borders */
  .ant-input:hover,
  .ant-input-affix-wrapper:hover,
  .ant-picker-input > input:hover,
  .ant-picker-input > input:focus,
  .ant-picker:hover,
  .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
    border-color: ${COLOR.primary};
  }

  .ant-input:focus,
  .ant-input-focused,
  .ant-input-affix-wrapper:focus,
  .ant-input-affix-wrapper-focused,
  .ant-picker-focused,
  .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-color: ${COLOR.primary};
    box-shadow: 0 0 0 2px ${PRIMARY_SHADOW};
  }

  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
    background-color: ${COLOR.primaryLight};
  }

  .ant-select-item-option-state {
    color: ${COLOR.primary};
  }

  /* DatePicker panel */
  .ant-picker-active-bar {
    background: ${COLOR.primary};
  }

  .ant-picker-header-view button:hover,
  .ant-picker-today-btn,
  .ant-picker-today-btn:hover {
    color: ${COLOR.primary};
  }

  .ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before {
    border-color: ${COLOR.primary};
  }

  .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {
    background: ${COLOR.primary};
  }

  /* Spin */
  .ant-spin {
    color: ${COLOR.primary};
  }

  .ant-spin-dot-item {
    background-color: ${COLOR.primary};
  }

  /* Intercom: keep the chat launcher above a fixed action bar (ActionBar). */
  .intercom-lightweight-app-launcher,
  .intercom-launcher-frame {
    bottom: var(--intercom-launcher-bottom, 20px) !important;
  }
`;

export default GlobalStyle;
